/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Dropbox_SearchInputs */

const es_tools_dropbox_search = /** @type {(inputs: Tools_Dropbox_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscando en Dropbox...`)
};

const en_tools_dropbox_search = /** @type {(inputs: Tools_Dropbox_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Searching Dropbox...`)
};

/**
* | output |
* | --- |
* | "Searching Dropbox..." |
*
* @param {Tools_Dropbox_SearchInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_dropbox_search = /** @type {((inputs?: Tools_Dropbox_SearchInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Dropbox_SearchInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_dropbox_search(inputs)
	return en_tools_dropbox_search(inputs)
});
export { tools_dropbox_search as "tools.dropbox.search" }